import(/* webpackMode: "eager" */ "/Users/sammyfung/projects/2026 HKOSCon/2026/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/sammyfung/projects/2026 HKOSCon/2026/src/app/topic/[topic]/page.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/sammyfung/projects/2026 HKOSCon/2026/src/app/topic/[topic]/TopicDescription.jsx");
;
import(/* webpackMode: "eager" */ "/Users/sammyfung/projects/2026 HKOSCon/2026/src/assets/images/placeholder.png");
